import { useTranslation } from 'react-i18next';

import { RadialProgress } from '@/components/ui/daisy';
import { WithClassname } from '@/components/ui/types';
import { Nullable } from '@/models/Model';
import percentage from '@/utils/statistics/percentage';
import { performanceColor } from '@/utils/statistics/performanceColor';

type PerformanceRadialProps = WithClassname & {
  performance: Nullable<number>;
  label: string;
};

export default function PerformanceRadial({
  performance,
  label,
  className,
}: PerformanceRadialProps) {
  const { t } = useTranslation('translation', { keyPrefix: 'common' });

  const value = Math.round(percentage(performance));

  return (
    <RadialProgress
      size="xs"
      thickness="xs"
      value={value}
      color={performanceColor(value)}
      classNames={{ base: className, track: 'text-base-300' }}
      aria-label={label}
    >
      <span className="text-[0.625rem] font-semibold">
        {t('performanceValue', { value })}
      </span>
    </RadialProgress>
  );
}
